import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";

var firebaseConfig = {
  apiKey: "AIzaSyCfBDXdpMeEfE0c0BAIIbglni2_GW4PgVk",
  authDomain: "avt-nobunaga-261b3.firebaseapp.com",
  databaseURL: "https://avt-nobunaga-261b3.firebaseio.com",
  projectId: "avt-nobunaga-261b3",
  storageBucket: "avt-nobunaga-261b3.appspot.com",
  messagingSenderId: "672227547638",
  appId: "1:672227547638:web:b68759941e044c0e1a4fd7",
  measurementId: "G-R4YRZ5DRD6",
};

export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const db = firebaseApp.firestore();
export const auth = firebaseApp.auth();
